import axios from 'axios';

export const getTicketingFields = async ({
  botId,
  appInstanceId,
  projectId,
  requestId,
  serviceDeskId,
}) => {
  const response = await axios.get(
    `/api/showcase.ticketing.fields?botId=${botId}&appInstanceId=${appInstanceId}&projectId=${projectId}&requestId=${requestId}${
      serviceDeskId ? `&serviceDeskId=${serviceDeskId}` : ''
    }`
  );
  return response.data;
};

export const getJiraAutoCompleteOptions = async ({
  wId,
  appInstanceId,
  url,
}) => {
  const response = await axios.get(
    `/api/showcase.ticketing.fields?wId=${wId}&appInstanceId=${appInstanceId}&url=${url}&type=auto_complete`
  );
  return response;
};

export const getJiraIssueLinkBlocks = async ({ appInstanceId }) => {
  const response = await axios.get(
    `/api/showcase.ticketing.fields?appInstanceId=${appInstanceId}&type=issue_link_blocks`
  );
  return response;
};

export const getJiraIssuePicker = async ({ appInstanceId, projectId }) => {
  const response = await axios.get(
    `/api/showcase.ticketing.fields?appInstanceId=${appInstanceId}&type=issue_picker&projectId=${projectId}`
  );
  return response;
};
export const getTaskAssignableUsers = async ({
  project,
  appInstanceId,
  query,
}) => {
  const response = await axios.get(
    `/api/showcase.ticketing.fields?project=${project}&appInstanceId=${appInstanceId}&query=${query}&type=assignable_users`
  );
  return response;
};
export const getJiraUsers = async ({
  project,
  appInstanceId,
  query,
}) => {
  const response = await axios.get(
    `/api/showcase.ticketing.fields?project=${project}&appInstanceId=${appInstanceId}&query=${query}&type=jira_users`
  );
  return response;
};
